import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { SnackbarApiService } from '../helper/snackbar-api.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private snackbarApi: SnackbarApiService) {}

  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(request).pipe(catchError((error: HttpErrorResponse) => this.handleApiError<T>(error)));
  }

  private handleApiError<T>(error: HttpErrorResponse): Observable<HttpEvent<T>> {
    if (
      [
        HttpStatusCode.NotFound,
        HttpStatusCode.BadRequest,
        HttpStatusCode.Forbidden,
        HttpStatusCode.PayloadTooLarge,
        HttpStatusCode.Conflict,
        HttpStatusCode.UnprocessableEntity,
        HttpStatusCode.InternalServerError,
        HttpStatusCode.GatewayTimeout,
      ].includes(error.status)
    ) {
      this.showErrorMessage(error);
    }

    return throwError(() => error);
  }

  private showErrorMessage(error: HttpErrorResponse) {
    const errorMessage = this.getErrorMessage(error);

    return this.snackbarApi.failure(errorMessage);
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    const errors = error.error?.errors;

    const message = Object.values(errors ?? {})
      .flatMap(v => (Array.isArray(v) ? v : []))
      .join(', ');

    if (message) {
      return message;
    }

    if (typeof error.error.message === 'string') {
      return error.error.message;
    }

    if (error?.message) {
      return error.message;
    }

    return error.statusText;
  }
}
